import AdminHelpSupporters from './SupportersConfigComponents/AdminHelpSupporters';
import AdminHelpVideos from './VideosConfigComponents/AdminHelpVideos';
import AdminHelpFAQs from './FAQConfigComponents/AdminHelpFAQs';
import { ContentSection } from '../../../../components/LayoutElements';
import { Suspense } from 'react';
import { Spinner, Stack } from '@fluentui/react';

export const HelpConfig = () => {
    return (
        <ContentSection>
            <Suspense
                fallback={
                    <Stack className="logindialog" horizontalAlign="center" verticalAlign="center">
                        <Spinner label="Loading..." />
                    </Stack>
                }
            >
                <AdminHelpSupporters />
                <AdminHelpVideos />
                <AdminHelpFAQs />
            </Suspense>
        </ContentSection>
    );
};
